@if (open()) {
	<tui-drawer *tuiPopup="true" class="drawer infinite-scroller insight-panel">
		<header>
			<span class="flex w-full items-start gap-2">
				<div class="flex min-w-0 flex-1 flex-col gap-1">
					<h2
						class="m-0 text-lg font-semibold leading-snug text-primary"
					>
						{{ title() }}
					</h2>
					@if (description()) {
						<p
							class="m-0 overflow-hidden text-ellipsis whitespace-nowrap text-sm text-primary-dark-300"
							[attr.title]="description()"
						>
							{{ description() }}
						</p>
					}
				</div>

				<button
					tuiIconButton
					type="button"
					appearance="ghost"
					size="s"
					class="shrink-0"
					data-action="close"
					[attr.aria-label]="'action.close' | transloco"
					(click)="onClose()"
				>
					<tui-icon icon="@tui.x" />
				</button>
			</span>
		</header>

		<div class="flex flex-col flex-grow p-6 gap-6 overflow-auto">
			@if (showMeta()) {
				<section
					class="flex flex-col gap-4"
					[attr.aria-label]="
						'analysis.insight.meta.label' | transloco
					"
				>
					<div class="grid grid-cols-2 gap-x-6 gap-y-4">
						<div
							class="col-start-1 row-start-1 flex min-w-0 flex-col gap-1"
							data-meta-cell="context"
						>
							@if (context()) {
								<p class="text-sm font-semibold">
									{{
										'analysis.insight.meta.context'
											| transloco
									}}
								</p>
								<p class="break-words">{{ context() }}</p>
							}
						</div>
						<div
							class="col-start-2 row-start-1 flex flex-col gap-1"
							data-meta-cell="status"
						>
							@if (meta()?.status; as status) {
								<p class="text-sm font-semibold">
									{{
										'analysis.insight.meta.status'
											| transloco
									}}
								</p>
								<span
									tuiBadge
									tuiStatus
									[appearance]="statusAppearance()"
								>
									{{
										'analysis.insight.status.' + status
											| transloco
									}}
								</span>
							}
						</div>
						<div
							class="col-start-1 row-start-2 flex flex-col gap-1"
							data-meta-cell="confidence"
						>
							@if (meta()?.confidence; as confidence) {
								<p class="text-sm font-semibold">
									{{
										'analysis.insight.meta.confidence'
											| transloco
									}}
								</p>
								<span
									tuiBadge
									tuiStatus
									[appearance]="confidenceAppearance()"
								>
									{{
										'analysis.insight.confidence.' +
											confidence | transloco
									}}
								</span>
							}
						</div>
						<div
							class="col-start-2 row-start-2 flex min-w-0 flex-col gap-1"
							data-meta-cell="generated"
						>
							@if (generatedLabel()) {
								<p class="text-sm font-semibold">
									{{
										'analysis.insight.meta.generated'
											| transloco
									}}
								</p>
								<p class="break-words">
									{{ generatedLabel() }}
								</p>
							}
						</div>
					</div>
					@if (meta()?.caveat; as caveat) {
						<p
							class="m-0 rounded-xl bg-accent-300 px-4 py-3 leading-normal text-primary-dark-200"
						>
							{{ caveat }}
						</p>
					}
				</section>
			}

			<div
				class="flex flex-col gap-4 leading-relaxed text-primary-dark-200"
			>
				@for (paragraph of paragraphs(); track $index) {
					<p class="m-0 whitespace-pre-line">{{ paragraph }}</p>
				}
			</div>
		</div>
	</tui-drawer>
}
